module.exports = __webpack_public_path__ + "img/selected-sparkling-steps.61329a0c.webp";